import { render } from "./DrawerApp.vue?vue&type=template&id=5d2c58a7"
import script from "./DrawerApp.vue?vue&type=script&lang=js"
export * from "./DrawerApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__